<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    东角头站<br>
站点介绍<br>
东角头站位于蛇口新街与湾厦路十字交叉路口，蛇口新街下跨十字路口，呈东西走向布置。车站周围有渔二村、中国海关、渔人码头、蛇口广场、南山妇幼保健院、蛇口影剧院。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:52	00:32	2号线	2分35秒	5分45秒<br>
莲塘	06:13	23:08	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:57	00:31	2号线	4分钟	5分钟<br>
莲塘	06:13	23:08	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:57	01:21	2号线	4分钟	5分钟<br>
莲塘	06:13	00:08	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br>
A出入口:<br>
南水步行街、湾厦路西侧（南）、蛇口渔二村、蛇口菜市场<br><br>
金世纪路、蛇口新街南侧、蛇口广场<br><br>
D出入口:<br>
蛇口新街北侧、湾厦路西侧（北）、深圳市南山区妇幼保健院、深圳市南山区蛇口学校<br><br>
公交换乘信息<br><br>
D出入口:<br>
公交站名： 南山妇幼保健院<br>
22、37、79、B737、M241、M484、M519<br><br>
B出入口:<br>
公交站名： 南山妇幼保健院<br>
22、37、79、B737、M241、M484、M519、N24、72、高峰专线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>